import { compareDecimalStrings } from './compareDecimalStrings';

//handles the enabling of the next button once the form is completely filled out
export default function activateNext(
  amount,
  reAmount,
  street1,
  city,
  zip,
  stateLocale,
  setNextDisabled,
  fieldOfficeRequired,
  fieldOffice,
) {
  if (fieldOfficeRequired) {
    if (!fieldOffice) {
      setNextDisabled(true);
      return;
    }
  }

  if (!amount || amount.length === 0) {
    setNextDisabled(true);
    return;
  }

  if (!reAmount || reAmount.length === 0) {
    setNextDisabled(true);
    return;
  }

  if (!street1 || street1.length === 0) {
    setNextDisabled(true);
    return;
  }

  if (!city || city.length === 0) {
    setNextDisabled(true);
    return;
  }

  if (!zip || zip.length === 0) {
    setNextDisabled(true);
    return;
  }

  if (!stateLocale || stateLocale.length === 0) {
    setNextDisabled(true);
    return;
  }

  if (!amount || !reAmount || !street1 || !city || !zip || !stateLocale) {
    return {
      err: 'MISSING_VAL',
      proceed: false,
    };
  } else {
    if (compareDecimalStrings(amount, reAmount)) {
      return setNextDisabled(false);
    } else {
      setNextDisabled(true);
      return;
    }
  }
}
